module.exports = __webpack_public_path__ + "static/media/graph_head.5d6e5a2d.png";